import React from 'react'
import RecipeList from './RecipeList'
import RecipeDetail from './RecipeDetail'
import {includes} from 'lodash';
import { useTranslation } from 'react-i18next';
import { currentLang } from '../../utils/functions';
import { siteInfo } from './../../utils/config';

const Recipes = ({match}) => {
	const {t} = useTranslation();

	const animals = siteInfo[currentLang()]['animal_types'];
	let {slug, page} = match.params;
	let filter = null;
	let detailPage = true;
	if(slug){
		if(parseInt(slug) > 0){
			//console.log(11);
			page = slug;
			detailPage = null;
		}
		if(includes(animals, t(slug))){
			//console.log(slug);
			filter=t(slug);
			detailPage = null;
		}

	}else{
		detailPage = null;
	}

	if(detailPage){
		filter = page;
		return (
			<RecipeDetail slug={slug} animal={filter} />
		)
	}else{
		return (
			<RecipeList page={page} filter={filter} />
		)
	}
}

export default Recipes
